import Axios from "axios";

export const SelectBSC = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BSRSCAM?type=SC&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "BSC_SELECT", payload: response.data });
    });
  };
};
